module.exports = __webpack_public_path__ + "static/img/poster1.fa8f952.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poster1.jpg
// module id = tscm
// module chunks = 1